import styled from 'styled-components';

import { ActionButton } from '@notino/react-styleguide-v20';

import { CypressTestNamespace } from '@utils/test';

export const DiscoveryBoxModalBodyWrapper = styled.div.attrs(() => ({
  className: CypressTestNamespace.ECartPageDiscoveryBox.DISCOVERY_BOX_MODAL,
}))`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const StyledDiscoveryBoxModalTitle = styled.p`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 2rem;
`;

export const StyledDiscoveryBoxFooter = styled.div`
  margin-top: 2rem;
`;

export const StyledDiscoveryBoxActionButton = styled(ActionButton)`
  width: 9.625rem;
`;
